import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GruposService, Vehiculo } from 'src/app/services/admin/grupos/grupos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-grupo-vehiculos',
  templateUrl: './grupo-vehiculos.component.html',
  styleUrls: ['./grupo-vehiculos.component.scss']
})
export class GrupoVehiculosComponent implements OnInit {

  @Input() grupoId: number;
  @Output() guardar = new EventEmitter<number[]>();
  @Output() cancelar = new EventEmitter<void>();

  loading = false;
  saving = false;
  searchControl = new FormControl('');
  vehiculos: Vehiculo[] = [];
  vehiculosFiltrados: Vehiculo[] = [];
  vehiculosSeleccionados: number[] = [];

  constructor(private gruposService: GruposService) { }

  ngOnInit(): void {
    this.cargarVehiculos();
    this.setupSearch();
  }

  cargarVehiculos(): void {
    this.loading = true;
    this.gruposService.getVehiculosDisponibles(this.grupoId).subscribe(
      (response: any) => {
        this.vehiculos = response.data || [];
        this.vehiculosFiltrados = [...this.vehiculos];
        this.vehiculosSeleccionados = this.vehiculos
          .filter(v => v.isAssigned)
          .map(v => v.cod_vehiculo);
        this.loading = false;
      },
      (error) => {
        console.error('Error cargando vehículos:', error);
        Swal.fire('Error', 'No se pudieron cargar los vehículos', 'error');
        this.loading = false;
      }
    );
  }

  setupSearch(): void {
    this.searchControl.valueChanges.subscribe(searchValue => {
      this.filtrarVehiculos(searchValue);
    });
  }

  filtrarVehiculos(search: string): void {
    const searchLower = search?.toLowerCase() || '';
    this.vehiculosFiltrados = this.vehiculos.filter(vehiculo =>
      vehiculo.cod_vehiculo.toString().includes(searchLower) ||
      vehiculo.matricula.toLowerCase().includes(searchLower)
    );
  }

  isAllSelected(): boolean {
    const numSelected = this.vehiculosSeleccionados.length;
    const numRows = this.vehiculosFiltrados.length;
    return numSelected > 0 && numSelected === numRows && numRows > 0;
  }

  toggleAllRows(): void {
    if (this.isAllSelected()) {
      this.vehiculosSeleccionados = this.vehiculosSeleccionados.filter(v =>
        !this.vehiculosFiltrados.find(vf => vf.cod_vehiculo === v)
      );
    } else {
      const noSeleccionados = this.vehiculosFiltrados
        .filter(v => !this.vehiculosSeleccionados.includes(v.cod_vehiculo))
        .map(v => v.cod_vehiculo);
      this.vehiculosSeleccionados = [...this.vehiculosSeleccionados, ...noSeleccionados];
    }
  }

  toggleVehiculo(vehiculo: Vehiculo): void {
    const index = this.vehiculosSeleccionados.indexOf(vehiculo.cod_vehiculo);
    if (index > -1) {
      this.vehiculosSeleccionados.splice(index, 1);
    } else {
      this.vehiculosSeleccionados.push(vehiculo.cod_vehiculo);
    }
  }

  isVehiculoSeleccionado(vehiculo: Vehiculo): boolean {
    return this.vehiculosSeleccionados.includes(vehiculo.cod_vehiculo);
  }

  guardarVehiculos(): void {
    this.saving = true;

    this.gruposService.saveVehiculos(this.grupoId, this.vehiculosSeleccionados).subscribe(
      (response: any) => {
        Swal.fire('Éxito', response.message || 'Vehículos asignados correctamente', 'success');
        this.saving = false;
        this.guardar.emit(this.vehiculosSeleccionados);
      },
      (error) => {
        console.error('Error guardando vehículos:', error);
        Swal.fire('Error', error?.error?.message || 'Error al guardar vehículos', 'error');
        this.saving = false;
      }
    );
  }

  cancelarForm(): void {
    this.cancelar.emit();
  }
}
